"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _Vim;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _Vim_brand = /*#__PURE__*/new WeakSet();
var _handleDragEnd = /*#__PURE__*/new WeakMap();
var _handleDragOver = /*#__PURE__*/new WeakMap();
var Vim = /*#__PURE__*/function () {
  function Vim(dom) {
    var _this = this;
    (0, _classCallCheck2["default"])(this, Vim);
    _classPrivateMethodInitSpec(this, _Vim_brand);
    _classPrivateFieldInitSpec(this, _handleDragEnd, function (e) {
      var block = e.block;
      if (!block) {
        return;
      }
      var codeMirror = _this.codeMirror;
      var textCode = _this.getCodeToText(block, Entry.Parser.PARSE_BLOCK);
      codeMirror.display.dragFunctions.leave(e);
      codeMirror.display.scroller.dispatchEvent(Entry.Utils.createMouseEvent('mousedown', e));
      var testArr = textCode.split('\n');
      var max = testArr.length - 1;
      var statementCursorLine = _this.doc.getCursor().line;
      testArr.forEach(function (text, i) {
        if (i !== max) {
          text += '\n';
        }
        codeMirror.replaceSelection(text);
      });

      //set cursor for statement block
      if (block.statements && block.statements.length) {
        statementCursorLine++;
        codeMirror.setCursor(statementCursorLine);
        if (codeMirror.getLine(statementCursorLine)) {
          codeMirror.replaceSelection('\n');
          codeMirror.setCursor(statementCursorLine);
        }
        CodeMirror.commands.indentAuto(codeMirror);
      }
      codeMirror.display.scroller.dispatchEvent(Entry.Utils.createMouseEvent('mouseup', e));
    });
    _classPrivateFieldInitSpec(this, _handleDragOver, function (e) {
      _this.codeMirror.display.dragFunctions.over(e);
    });
    if (typeof dom === 'string') {
      dom = $("#".concat(dom));
    } else {
      dom = $(dom);
    }
    if (dom.prop('tagName') !== 'DIV') {
      return console.error('Dom is not div element');
    }
    this._parentView = dom;
    this.createDom(dom);
    this._parser = new Entry.Parser(null, null, this.codeMirror);
    Entry.addEventListener('hwChanged', function (e) {
      if (Entry.hw.hwModule) {
        var name = Entry.hw.hwModule.name;
        name = name[0].toUpperCase() + name.slice(1);
        if (name === 'ArduinoExt') {
          name = 'Arduino';
        }
        Vim.PYTHON_IMPORT_HW = "\nimport ".concat(name, "\n");
        Vim.INEDITABLE_LINE_PY = 4;
      } else {
        Vim.PYTHON_IMPORT_HW = '';
        Vim.INEDITABLE_LINE_PY = 3;
      }
    });
  }
  return (0, _createClass2["default"])(Vim, [{
    key: "createDom",
    value: function createDom(dom) {
      var _this2 = this;
      var parent = dom;
      this.view = Entry.Dom('div', {
        parent: parent,
        "class": 'entryVimBoard'
      });
      this.codeMirror = CodeMirror(this.view[0], {
        lineNumbers: true,
        value: '',
        mode: {
          name: 'javascript',
          globalVars: true
        },
        theme: 'default',
        indentUnit: 4,
        indentWithTabs: true,
        styleActiveLine: true,
        extraKeys: {
          'Ctrl-Space': 'autocomplete',
          Tab: function Tab(cm) {
            var spaces = Array(cm.getOption('indentUnit') + 1).join(' ');
            cm.replaceSelection(spaces);
          }
        },
        //gutters: ["CodeMirror-linenumbers", "breakpoints"],
        lint: true,
        viewportMargin: 10
      });
      var dShowHint = (0, _debounce["default"])(function () {
        if (Entry.isTextMode) {
          _this2.codeMirror.showHint({
            completeSingle: false,
            globalScope: _assertClassBrand(_Vim_brand, _this2, _getAssistScope).call(_this2)
          });
        }
      }, 250);
      this.codeMirror.on('keydown', function (cm, event) {
        if (Entry && Entry.keyPressed) {
          Entry.keyPressed.notify(event, true);
        }
        if (event.key.length === 1) {
          dShowHint();
        }
      });
      var dClear = (0, _debounce["default"])(function () {
        var input = _this2.codeMirror.display && _this2.codeMirror.display.input ? _this2.codeMirror.display.input : undefined;
        if (input && input.composing) {
          input.poll();
          input.composing.range.clear();
          input.composing = null;
        }
      }, 250);
      this.codeMirror.on('keyup', function (cm, event) {
        //i.e composition bug
        dClear();
        if (event.key === 'Backspace') {
          dShowHint();
        }
      });
      this.doc = this.codeMirror.getDoc();
      var target = this.view[0];
      target.removeEventListener('dragEnd', _classPrivateFieldGet(_handleDragEnd, this));
      target.removeEventListener('dragOver', _classPrivateFieldGet(_handleDragOver, this));
      target.addEventListener('dragEnd', _classPrivateFieldGet(_handleDragEnd, this));
      target.addEventListener('dragOver', _classPrivateFieldGet(_handleDragOver, this));
    }
  }, {
    key: "hide",
    value: function hide() {
      this.view.addClass('entryRemove');
      this.view.remove();
    }
  }, {
    key: "show",
    value: function show() {
      this.view.removeClass('entryRemove');
      this._parentView.append(this.view);
    }
  }, {
    key: "clearText",
    value: function clearText() {
      this.codeMirror.setValue('');
    }
  }, {
    key: "textToCode",
    value: function textToCode(textType) {
      var type = textType;
      if (type === Vim.TEXT_TYPE_JS) {
        this._parserType = Vim.PARSER_TYPE_JS_TO_BLOCK;
        this._parser.setParser(this._mode, this._parserType, this.codeMirror);
      } else if (type === Vim.TEXT_TYPE_PY) {
        this._parserType = Vim.PARSER_TYPE_PY_TO_BLOCK;
        this._parser.setParser(this._mode, this._parserType, this.codeMirror);
      }
      var textCode = this.codeMirror.getValue();
      var cursor = this.doc.getCursor();
      textCode = textCode.replace(/\t/gm, '    ');
      this.codeMirror.setValue(textCode);
      this.doc.setCursor(cursor);
      return this._parser.parse(textCode);
    }
  }, {
    key: "codeToText",
    value: function codeToText(code, mode) {
      var doc;
      var textCode;
      var codeDescription;
      if (mode) {
        this._mode = mode.runType;
      }
      var textType = mode.textType;
      this._oldParserType = mode.textType;
      if (textType === Vim.TEXT_TYPE_JS) {
        this._parserType = Vim.PARSER_TYPE_BLOCK_TO_JS;
        if (this._oldParserType !== this._parserType) {
          this._parser.setParser(this._mode, this._parserType, this.codeMirror);
        }
        this._oldParserType = this._parserType;
      } else if (textType === Vim.TEXT_TYPE_PY) {
        this._parserType = Vim.PARSER_TYPE_BLOCK_TO_PY;
        if (this._oldParserType !== this._parserType) {
          this._parser.setParser(this._mode, this._parserType, this.codeMirror);
        }
        this._oldParserType = this._parserType;
      }
      if (Entry.playground) {
        this._currentObject = Entry.playground.object;
      }
      this._parser._hasDeclaration = false;
      if (textType === Vim.TEXT_TYPE_PY) {
        if (this._currentObject) {
          codeDescription = "# ".concat(this._currentObject.name).concat(Lang.TextCoding.python_code);
          textCode = this._parser.parse(code, Entry.Parser.PARSE_GENERAL);
          if (textType === Vim.TEXT_TYPE_PY) {
            textCode = codeDescription.concat('\n\n').concat(Vim.PYTHON_IMPORT_ENTRY).concat(Vim.PYTHON_IMPORT_HW).concat('\n\n').concat(textCode);
          }
          this.codeMirror.setValue(textCode);
          if (textType === Vim.TEXT_TYPE_PY) {
            this.codeMirror.getDoc().markText({
              line: 0,
              ch: 0
            }, {
              line: Vim.INEDITABLE_LINE_PY,
              ch: 0
            }, {
              readOnly: true,
              inclusiveLeft: true
            });
          }
          doc = this.codeMirror.getDoc();
          doc.setCursor({
            line: doc.lastLine() - 1
          });
        } else {
          this.clearText();
        }
      } else if (textType === Vim.TEXT_TYPE_JS) {
        textCode = this._parser.parse(code, Entry.Parser.PARSE_GENERAL);
        this.codeMirror.setValue(textCode);
        doc = this.codeMirror.getDoc();
        doc.setCursor({
          line: doc.lastLine() - 1
        });
      }
      if (Entry.isTextMode) {
        this._parser._onRunError = false;
      }
    }
  }, {
    key: "getCodeToText",
    value: function getCodeToText(code, parseType) {
      _assertClassBrand(_Vim_brand, this, _setParserUsingOldTextType).call(this);
      return parseType ? this._parser.parse(code, parseType) : this._parser.parse(code, Entry.Parser.PARSE_SYNTAX);
    }
  }, {
    key: "setParserAvailableCode",
    value: function setParserAvailableCode(blockMenuCode, boardCode) {
      this._parser.setAvailableCode(blockMenuCode, boardCode);
    }
  }, {
    key: "getBlockSyntax",
    value: function getBlockSyntax(datum) {
      var syntax = null;
      _assertClassBrand(_Vim_brand, this, _setParserUsingOldTextType).call(this);
      if (this._parser._execParser) {
        syntax = this._parser._execParser.searchSyntax(datum);
      }
      return syntax;
    }
  }]);
}();
_Vim = Vim;
function _getAssistScope() {
  var execParser = this._parser._execParser;
  if (execParser && execParser.getAssistScope) {
    return execParser.getAssistScope();
  }
}
function _setParserUsingOldTextType() {
  var textType = this.workspace.oldTextType;
  if (textType === _Vim.TEXT_TYPE_JS) {
    this._parserType = _Vim.PARSER_TYPE_BLOCK_TO_JS;
    this._parser.setParser(this._mode, this._parserType, this.codeMirror);
  } else if (textType === _Vim.TEXT_TYPE_PY) {
    this._parserType = _Vim.PARSER_TYPE_BLOCK_TO_PY;
    this._parser.setParser(this._mode, this._parserType, this.codeMirror);
  }
}
(0, _defineProperty2["default"])(Vim, "MAZE_MODE", 1);
(0, _defineProperty2["default"])(Vim, "WORKSPACE_MODE", 2);
(0, _defineProperty2["default"])(Vim, "TEXT_TYPE_JS", 0);
(0, _defineProperty2["default"])(Vim, "TEXT_TYPE_PY", 1);
(0, _defineProperty2["default"])(Vim, "PARSER_TYPE_JS_TO_BLOCK", 0);
(0, _defineProperty2["default"])(Vim, "PARSER_TYPE_PY_TO_BLOCK", 1);
(0, _defineProperty2["default"])(Vim, "PARSER_TYPE_BLOCK_TO_JS", 2);
(0, _defineProperty2["default"])(Vim, "PARSER_TYPE_BLOCK_TO_PY", 3);
(0, _defineProperty2["default"])(Vim, "INEDITABLE_LINE_PY", 3);
(0, _defineProperty2["default"])(Vim, "PYTHON_IMPORT_ENTRY", 'import Entry');
(0, _defineProperty2["default"])(Vim, "PYTHON_IMPORT_HW", '');
Entry.Vim = Vim;